export class MenuPaths{
    static readonly FloorPlans: string="floorplans";
    static readonly Availability: string="availability";
    static readonly RentalOptions: string="rentaloptions";
    static readonly IDVerification: string="idverification";
    static readonly People: string="people";
    static readonly CustomApplicantInfo: string="customapplicationform";
    static readonly AdditionalOccupant: string="additionaloccupant";
    static readonly ApplicationCharges: string="fees";
    static readonly ApplicationChargesStep2: string="fees2";
    static readonly ApplicationChargesStep3: string="fees3";
    static readonly PaymentRedirect: string="paymentredirect";
    static readonly LeaseSummary: string="summary";
    static readonly Screening: string="screening";
    static readonly LeaseCreation:string ="lease";
    static readonly Notifications:string ="notifications";  
    static readonly Application: string="application";
    static readonly Pets: string="pets"; 
    static readonly RentEstimate: string="rentestimate"; 
    static readonly UploadDocument: string="uploaddocument"; 
    static readonly AddOns: string="addons";
    static readonly Rooms: string="rooms"; 
    static readonly RoommatePreferences: string="roommatematching"; 
   
    static readonly Installment: string="installments"; 
    static readonly GetStarted: string="getstarted";
    static readonly Landing: string="landing";
    static readonly IncomeInfo: string="incomeinfo";
    static readonly PersonalInformation : string="studentdetails";
    static readonly reviewdocuments: string = "reviewdocuments";
    static readonly MyApplications: string = "myaccounts";
    static readonly MyProfile: string = "myprofile";
}